
import React from 'react';
import BaseComponent from './Base';
import { Link } from 'react-router-dom';

class LegalPersons extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : props.subModuleName,
        filterParams:[]
      };

      super(props, config);
    }
    componentWillReceiveProps(props){
      this.state.subModuleName = props.subModuleName;
      this.state.data = null;
      this.refresh();
    }
    renderTempLegals(_t){
      var data = JSON.parse(_t.data);
      return (<div className={this.state.subModuleName === "issues" ? "col-md-2 col-sm-12 col-xs-12" : "col-md-3 col-sm-12 col-xs-12"}>
                <div className={"box box-warning"}>
                  <div className="box-body">
                    <ul className="products-list product-list-in-box">
                      {this.state.subModuleName === "issues" &&
                        <div className="item">
                          <p className="message">
                            <p><Link to={"/issue/edit/t/" + _t.id} className="name">دوره {data.volume}, شماره {data.issue}, سال {_t.aff_type}</Link></p>
                            {_t.status === 1 && <span className="label label-warning pull-left">در انتظار تایید</span>}
                            {_t.status === 3 && <span className="label label-danger pull-left">تایید نشد</span>}
                          </p>
                        </div>
                      }
                    </ul>
                  </div>
                </div>
              </div>);
    }
    renderListView(){
      return (
        <div>
          {this.state.subModuleName === 'issues' &&
            <div className="row" style={{"marginBottom":"19px"}}>
              <div className="col-md-12 col-sm-12 col-xs-12">
                <Link to="/issue/new/" className="btn btn-success">
                  <i className="fa fa-plus"></i> افزودن شماره جدید
                </Link>
              </div>
            </div>
          }
          {!this.isEmpty(this.state.data.records.length) || !this.isEmpty(this.state.data.temps) ? [
              <div className="row">
                {this.state.data.temps.map(_t=>
                  this.renderTempLegals(_t)
                )}
              </div>
            ,
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className={this.state.subModuleName === "issues" ? "col-md-2 col-sm-12 col-xs-12" : "col-md-3 col-sm-12 col-xs-12"}>
                  <div className={_t.status === 0 ? "box box-danger" : "box box-success" }>
                    <div className="box-body">
                      <ul className="products-list product-list-in-box">
                        {this.state.subModuleName === "issues" &&
                          <div className="item">
                            <p className="message">
                              <p><Link to={"/issue/edit/" + _t.person_id} className="name">دوره {_t.volume}, شماره {_t.issue}, سال {_t.aff_type}</Link></p>
                              <span className="label label-info pull-left"><i className="fal fa-clock"></i> {this.g2j(_t.start,0)}</span>
                            </p>
                          </div>
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ]:
            <h4 className="alert alert-info text-center">کاربر گرامی در حال حاضر شما آیتم ثبت شده ای ندارید</h4>
          }
        </div>
      );
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess();
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return this.renderListView();
    }
  }
  export default LegalPersons;